import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { preloaderReducer } from 'redux/modules/preloader';
import { userProfileReducer } from './modules/user/userprofile';
import { userPreferencesReducer } from './modules/user/userpreferences';
import { userCardReducer } from './modules/user/usercard';
import { userSearchResultsReducer } from './modules/search/usersearchresults';
import { reducer as reduxFormReducer } from 'redux-form';
import { whoToFollowReducer } from './modules/whotofollow';
import { modalReducer } from './modules/modal';
import { shopCardReducer } from './modules/shop/shopcard';
import { shopProfileReducer } from './modules/shop/shopprofile';
import { userShopsReducer } from './modules/user/usershops';
import { IStore } from './IStore';
import { FetchReducer } from './modules/fetch';
import { productsReducer } from './modules/product/products';
import { manageProductReducer } from './modules/product/manageproduct';
import { manageArticleReducer } from './modules/magazine/article/managearticle';
import { articlesReducer } from './modules/magazine/article/articles';
import { recentArticlesReducer } from './modules/magazine/article/recentarticles';
import { similarArticlesReducer } from './modules/magazine/article/similararticles';
import { nextArticleReducer } from './modules/magazine/article/nextarticle';
import { articleCardReducer } from './modules/magazine/article/articlecard';
import { manageArticleTagReducer } from './modules/magazine/article/managearticletag';
import { userLanguageReducer } from './modules/user/userlanguage';
import { reducer as notifReducer } from 'redux-notifications';
import { articleTagsReducer } from 'redux/modules/magazine/article/articletags';
import { articleSettingsReducer } from 'redux/modules/magazine/article/articlesettings';
import { magazineHamburgerMenuReducer } from 'redux/modules/magazine/magazinehamburgermenu';
import { sideMenuReducer } from 'redux/modules/menus/sidemenu';
import { topMenuReducer } from 'redux/modules/menus/topmenu';
import { searchReducer } from 'redux/modules/search/search';
import { articleSearchResultsReducer } from './modules/search/articlesearchresults';
import { wardrobeItemSearchResultsReducer } from './modules/search/wardrobeitemsearchresults';
import { pollsReducer } from 'redux/modules/polls/polls';
import { managePollReducer } from 'redux/modules/polls/managepoll';
import { pollSearchResultsReducer } from './modules/search/pollsearchresults';
import { imageReducer } from './modules/image';
import { manageShopReducer } from './modules/shop/manageshop';
import { manageShopShippingOptionReducer } from './modules/shop/manageshopshippingoption';
import { createShopReducer } from './modules/shop/createshop';
import { domainValuesReducer } from './modules/domainvalues';
import { manageUserShippingAddressReducer } from './modules/user/shipping/manageusershippingaddress';
import { userShippingAddressesReducer } from './modules/user/shipping/usershippingaddresses';
import { productSearchResultsReducer } from './modules/search/productsearchresults';
import { productCardReducer } from './modules/product/productcard';
import { youMayAlsoLikeProductsReducer } from './modules/product/youmayalsolike';
import { shopSearchResultsReducer } from './modules/search/shopsearchresults';
import { productsImportImagesReducer } from './modules/product/productsimportimages';
import { manageWardrobeItemReducer } from './modules/wardrobe/managewardrobeitem';
import { wardrobeItemCardReducer } from './modules/wardrobe/wardrobeitemcard';
import { onboardingQuizReducer } from './modules/onboardingquiz';
import { outfitReducer } from './modules/outfit/outfit';
import { outfitsReducer } from './modules/outfit/outfits';
import { manageOutfitReducer } from './modules/outfit/manageoutfit';
import { outfitCardReducer } from './modules/outfit/outfitcard';
import { wishlistReducer } from './modules/user/wishlist';
import { userOrdersReducer } from './modules/user/orders';
import { shopOrdersReducer } from './modules/shop/orders';
import { orderCardReducer } from './modules/user/ordercard';
import { userFeedReducer } from './modules/user/userfeed';
import { cartReducer } from './modules/cart';
import { shopOrderCardReducer } from './modules/shop/shopordercard';
import { errorReducer } from './modules/error';
import { shopDashboardReducer } from './modules/shop/dashboard';
import { helpCenterReducer } from './modules/helpcenter';
import { shopReviewsReducer } from './modules/shop/shopreviews';
import { notificationsDropdownReducer } from './modules/notifications/notificationsdropdown';
import { notificationsPageReducer } from './modules/notifications/notificationspage';
import { menuItemReducer } from './modules/menuitem/menuitem';
import { menuItemsReducer } from './modules/menuitem/menuitems';
import { menuEditorReducer } from './modules/menueditor';
import { mainMenuReducer } from './modules/menus/mainmenu';
import { shopsReducer } from './modules/shop/shops';
import { officesReducer } from './modules/shop/offices';
import { appointmentsReducer } from './modules/shop/appointments';
import { bookingTimetablesReducer } from './modules/shop/bookingtimetables';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { shopBookingTepmplatesReducer } from './modules/shop/bookingtemplates';
import { serviceGroupsReducer } from './modules/shop/serviceGroups';
import { bookAppointmentReducer } from './modules/bookappointment';
import { shopServiceTemplatesReducer } from './modules/shop/servicetemplates';
import { paymentMethodsReducer } from './modules/user/userpaymentmethods';
import { articleCommentsReducer } from './modules/magazine/article/articlecomments';
import { addArticleCommentReducer } from './modules/magazine/article/addarticlecomment';
import { editArticleCommentReducer } from './modules/magazine/article/editarticlecomment';
import { restrictedModeReducer } from './modules/restrictedmode';
import { discountStrategyReducer } from './modules/shop/discountStrategies';
import { subscriptionPlansReducer } from './modules/subscriptionplans/subscriptionplans';
import { shopSubscriptionPlansReducer } from './modules/subscriptionplans/shopsubscriptionplans';
import { landingPageDataReducer } from './modules/landingpagedata';

const { reducer } = require('redux-connect');

const cookiesPersistConfig = {
	key: 'userprofile',
	storage,
	blacklist: ['isFetching', 'user'],
};

const shopDashboardPersistConfig = {
	key: 'root',
	storage,
	whitelist: ['selectedPeriodicity'],
};

const menuItemPersistConfig = {
	key: 'root',
	storage,
	whitelist: ['activeMenuItemId'],
};

const rootReducer: Redux.Reducer<IStore> = combineReducers<IStore>({
	routing: routerReducer,
	reduxAsyncConnect: reducer,
	form: reduxFormReducer,
	modals: modalReducer,
	preloader: preloaderReducer,
	userprofile: persistReducer(cookiesPersistConfig, userProfileReducer),
	usercard: userCardReducer,
	userPreferences: userPreferencesReducer,
	userSearchResults: userSearchResultsReducer,
	whoToFollow: whoToFollowReducer,
	fetchDefault: FetchReducer,
	shopcard: shopCardReducer,
	shopProfile: shopProfileReducer,
	shopBookingTemplates: shopBookingTepmplatesReducer,
	shopServiceTemplates: shopServiceTemplatesReducer,
	serviceGroups: serviceGroupsReducer,
	userShops: userShopsReducer,
	products: productsReducer,
	manageProduct: manageProductReducer,
	productSearchResults: productSearchResultsReducer,
	shopSearchResults: shopSearchResultsReducer,
	manageArticle: manageArticleReducer,
	manageArticleSettings: articleSettingsReducer,
	articles: articlesReducer,
	articleSearchResults: articleSearchResultsReducer,
	recentArticles: recentArticlesReducer,
	similarArticles: similarArticlesReducer,
	nextArticle: nextArticleReducer,
	articleCard: articleCardReducer,
	manageArticleTag: manageArticleTagReducer,
	articleTags: articleTagsReducer,
	userLanguage: userLanguageReducer,
	notifs: notifReducer,
	magazineHamburgerMenu: magazineHamburgerMenuReducer,
	sideMenu: sideMenuReducer,
	topMenu: topMenuReducer,
	search: searchReducer,
	polls: pollsReducer,
	managePoll: managePollReducer,
	pollSearchResults: pollSearchResultsReducer,
	image: imageReducer,
	manageShop: manageShopReducer,
	manageShopShippingOption: manageShopShippingOptionReducer,
	createShop: createShopReducer,
	domainValues: domainValuesReducer,
	manageUserShippingAddress: manageUserShippingAddressReducer,
	userShippingAddresses: userShippingAddressesReducer,
	productCard: productCardReducer,
	youMayAlsoLikeProducts: youMayAlsoLikeProductsReducer,
	productsImportImages: productsImportImagesReducer,
	manageWardrobeItem: manageWardrobeItemReducer,
	wardrobeItemSearchResults: wardrobeItemSearchResultsReducer,
	wardrobeItemCard: wardrobeItemCardReducer,
	wishlist: wishlistReducer,
	onboardingQuiz: onboardingQuizReducer,
	outfit: outfitReducer,
	outfits: outfitsReducer,
	manageOutfit: manageOutfitReducer,
	outfitCard: outfitCardReducer,
	userOrders: userOrdersReducer,
	shopOrders: shopOrdersReducer,
	orderCard: orderCardReducer,
	shopOrderCard: shopOrderCardReducer,
	cart: cartReducer,
	shopDashboard: persistReducer(shopDashboardPersistConfig, shopDashboardReducer),
	helpCenter: helpCenterReducer,
	shopReviews: shopReviewsReducer,
	notificationsDropdown: notificationsDropdownReducer,
	notificationsPage: notificationsPageReducer,
	menuItem: persistReducer(menuItemPersistConfig, menuItemReducer),
	menuItems: menuItemsReducer,
	menuEditor: menuEditorReducer,
	mainMenu: mainMenuReducer,
	userFeed: userFeedReducer,
	appointments: appointmentsReducer,
	bookingTimetables: bookingTimetablesReducer,
	shops: shopsReducer,
	offices: officesReducer,
	userPaymentMethods: paymentMethodsReducer,
	bookAppointment: bookAppointmentReducer,
	error: errorReducer,
	articleComments: articleCommentsReducer,
	addArticleCommentReducer: addArticleCommentReducer,
	editArticleCommentReducer: editArticleCommentReducer,
	restrictedMode: restrictedModeReducer,
	discountStrategyReducer,
	subscriptionPlansReducer,
	shopSubscriptionPlansReducer,
	landingPageDataReducer,
});

export default rootReducer;
